import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const section = (title, children) => (
  <div style={{ marginTop: 40 }}>
    <p className="boldsub" style={{ fontSize: "0.95em", letterSpacing: 1 }}>{title.toUpperCase()}</p>
    {children}
  </div>
);

const p = (text) => (
  <p className="intro" style={{ textAlign: "left", marginTop: 8 }}>{text}</p>
);

const li = (text) => (
  <li className="intro" style={{ textAlign: "left", marginTop: 4 }}>{text}</li>
);

function CrewPrivacy() {
  return (
    <section>
      <Container>
        <Navbar />
        <Row style={{ paddingTop: 60, paddingBottom: 100 }}>
          <Col lg={8} md={10} style={{ textAlign: "left" }}>

            <h1 className="name py-4" style={{ textAlign: "left" }}>Crew Privacy Policy</h1>
            <p className="intro" style={{ color: "grey", textAlign: "left" }}>Last updated: 2026-05-29</p>
            {p('Crew ("we", "us", "the app") is a motorcycle group-ride tracking app built by Tianxiang Ren. This policy explains what data we collect and how we use it.')}

            {section("Information We Collect", <>
              <p className="boldsub" style={{ fontSize: "0.85em", marginTop: 16 }}>Account info.</p>
              {p("Email address (and name, if provided via Apple or Google Sign In). Used to identify your account.")}

              <p className="boldsub" style={{ fontSize: "0.85em", marginTop: 16 }}>Profile info.</p>
              {p("Display name, optional rider tag (@username), optional bike description, and an avatar seed used to generate a profile picture. Visible to other riders on the map.")}

              <p className="boldsub" style={{ fontSize: "0.85em", marginTop: 16 }}>Location data.</p>
              {p("When you turn on location sharing in the app:")}
              <ul>
                {li("Your real-time GPS location, speed, and heading are stored on our servers and shared with: riders you have added as friends; members of any group ride room you have joined; if you explicitly opt into \"Public Lobby\" mode, any rider within 100 miles who has also enabled Public Lobby.")}
                {li("Location sharing continues in the background until you turn it off in the app. Closing the app does not stop sharing.")}
                {li("We never sell location data and never share it outside the cases listed above.")}
              </ul>

              <p className="boldsub" style={{ fontSize: "0.85em", marginTop: 16 }}>Voice messages.</p>
              {p("If you record a voice message for your crew, the audio is uploaded to our servers and made available to your friends and ride-room members. Voice messages are deleted from storage when you delete them or your account.")}

              <p className="boldsub" style={{ fontSize: "0.85em", marginTop: 16 }}>Hazard reports.</p>
              {p("When you tag a police report on the map, the report's location is stored anonymously and broadcast to nearby riders. Reports auto-expire after 15 minutes.")}

              <p className="boldsub" style={{ fontSize: "0.85em", marginTop: 16 }}>Push notification token.</p>
              {p("A device token from Apple Push Notification Service so we can send you alerts (police nearby, ride invitations). You can disable specific notification categories in the Profile tab.")}
            </>)}

            {section("Third-Party Services", <>
              <ul style={{ marginTop: 12 }}>
                {li("Supabase (database, authentication, storage): hosts your account, location, and voice data.")}
                {li("Mapbox (maps): renders the map. Your location is sent to Mapbox only as part of rendering the map view.")}
                {li("Expo Push Service (Apple Push Notification gateway): relays push notifications.")}
                {li("DiceBear (avatar generation): receives only an opaque \"seed\" string to generate your profile avatar — no personal data.")}
                {li("Apple Sign In / Google Sign In: authentication only.")}
              </ul>
            </>)}

            {section("Your Rights", <>
              <ul style={{ marginTop: 12 }}>
                {li("Access: contact us at the email below to request a copy of your data.")}
                {li("Deletion: delete your account at any time from the Profile tab → Delete Account. This permanently removes your account, profile, friends, location history, voice messages, and push token.")}
                {li("Opt-out: turn off location sharing or Public Lobby at any time from the map screen. Toggle push notifications in the Profile tab.")}
              </ul>
            </>)}

            {section("Data Retention", <>
              <ul style={{ marginTop: 12 }}>
                {li("Account and profile data: kept until you delete your account.")}
                {li("Location data: continuously overwritten with your latest position.")}
                {li("Voice messages: kept until deleted by you or by replacing them with a new recording.")}
                {li("Hazard reports: auto-deleted 15 minutes after posting.")}
              </ul>
            </>)}

            {section("Children", <>
              {p("Crew is not intended for users under 13. We do not knowingly collect data from children under 13.")}
            </>)}

            {section("Changes to This Policy", <>
              {p("We may update this policy. Material changes will be reflected in the \"Last updated\" date above. Continued use of the app after updates constitutes acceptance.")}
            </>)}

            {section("Contact", <>
              {p("Questions or data requests: rentxiang@gmail.com")}
            </>)}

          </Col>
        </Row>
        <Footer />
      </Container>
    </section>
  );
}

export default CrewPrivacy;
